//This is home page, It will contains all the sections require in this page.

//Import all the require sections here
import HeroSection from "../Sections/Hero/index";
import About from "../Sections/About/index";
import Services from "../Sections/Services/index";
import Testimonials from "../Sections/Testimonials/index";
import Contact from "../Sections/Contact/index";
import styled from "styled-components";
import OurWork from "../Sections/OurWork";
import HorizontalMediaPanl from "../components/HorizontalMediaPanel";
import Technologies from "../Sections/OurWork/Technologies";
import Ourprojects from "../Sections/OurWork/ourprojects";
import RunningNumbers from "../Sections/OurWork/runningNumbers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* position: relative; */
`;

const Home = () => {
  return (
    <Container>
      <HeroSection />
      <About />
      <Services />
      <Testimonials />
      <OurWork />
      <Technologies />
      <Ourprojects />
      <RunningNumbers />
      <Contact />
    </Container>
  );
};

export default Home;
